<template>
  <!-- 后台管理模块父组件移动端设计 -->
  <div class="modul-home">
    <!-- 装修操作 -->
    <section class="modul-operation">
      <!-- 组件 -->
      <!-- 左侧抽屉式sliderassembly组件 -->
      <!-- 展开/收起按钮 -->
      <div class="toggle-sidebar-btn-container">
        <div
          v-if="!isSidebarOpen"
          class="toggle-sidebar-btn open"
          @click="toggleSidebar(true)"
        >
          展开 >>
        </div>
        <div
          v-else
          class="toggle-sidebar-btn close"
          @click="toggleSidebar(false)"
        >
          收起 >>
        </div>
        <transition name="sidebar-slide">
          <div class="sidebar-container" v-show="isSidebarOpen">
            <sliderassembly
              ref="sliderassembly"
              :pointer="pointer"
              :components="pageComponents"
              @componenmanagement="componenmanagement"
              :rightcom="rightcom"
            />
          </div>
        </transition>
      </div>

      <!-- 中间预览 -->
      <div
        class="phone"
        style="display: flex; flex-direction: column; align-items: center"
      >
        <div
          class="preview-actions"
          style="display: flex; justify-content: flex-end"
        >
          <div class="">
            <button
              class="carousel-btn consult-btn"
              @click="handlePreview"
              style="padding: 5px 15px"
            >
              预览
            </button>
            <button
              class="carousel-btn consult-btn"
              style="padding: 5px 15px"
              @click="handleSave"
            >
              保存
            </button>
            <button
              class="carousel-btn"
              style="padding: 5px 15px"
              @click="Preservation"
            >
              发布
            </button>
          </div>
          <!-- <PublicNavBar
            :items="navbarList"
            direction="horizontal"
            :horizontalWidth="horizontalWidth"
            @handleItemClick="navbarClick"
            :activeIndex="activeNavbarIndex"
            :itemSpacingArray="[0, 40, 40, 40]"
          /> -->
        </div>
        <div
          class="phoneBack"
          style="
            position: relative;
            margin-top: 10px;
            flex-direction: column;
            justify-content: flex-end;
            align-items: center;
            display: flex;
            height: 95%;
            margin-left: 55px;
          "
        >
          <div
            class="headerTop"
            :class="{ 'header-selected': isHeaderSelected }"
            style="position: relative; width: 375px"
          >
            <headerTop
              :pageSetup="pageSetup"
              :background="pageSetup.navbarBackground"
              @click.native="headTop"
              @left-click="handleLeftClick"
            />
          </div>
          <div
            class="phoneAll"
            ref="imageTofile"
            id="imageTofile"
            style="
              position: relative;
              width: 600px;
              display: flex;
              justify-content: center;
              height: 100%;
            "
          >
            <!-- 头部导航 -->
            <!-- 主体内容  :style="{
                'background-color': pageSetup.bgColor,
                ,
              }"height: calc(100vh - 100px);-->
            <section
              :class="{ 'phone-container-isHaveStyle': isHaveStyle }"
              class="phone-container"
              :style="{
                backgroundColor: pageSetup.bgColor,
                backgroundImage: 'url(' + pageSetup.bgImg + ')',
              }"
              style="
                width: 375px;

                box-shadow: 0 0 14px 0 rgb(0 0 0 / 10%);
              "
              @drop="drop($event)"
              @dragover="allowDrop($event)"
              @dragleave="dragleaves($event)"
            >
              <div :class="pointer.show ? 'pointer-events' : ''">
                <!-- 动态组件 -->
                <component
                  v-if="item.component !== 'tabbar'"
                  :is="item.component"
                  v-for="(item, index) in pageComponents"
                  :key="index"
                  :data-index="index"
                  :datas="item.setStyle"
                  :isShow="$utils.strToBool(item.isShow)"
                  :style="{
                    border:
                      item.active && deleShow && item.component !== 'my'
                        ? '2px solid #155bd4'
                        : '',
                  }"
                  @click.native="activeComponent(item, index)"
                  class="componentsClass"
                  :data-type="item.type"
                  @handleCallbackComponent="handleCallbackComponent"
                  @navigation-click="handleNavigationClick"
                >
                  <!-- 左侧组件库名称 -->
                  <template #name>
                    <div
                      class="left-name"
                      :class="{ active: item.active && deleShow }"
                    >
                      <span class="f12">{{ item.text }}</span>
                      <i
                        class="el-icon-caret-right"
                        :class="{ active: item.active && deleShow }"
                      ></i>
                    </div>
                  </template>
                  <!-- 右侧组件删除按钮 -->
                  <template #deles>
                    <div
                      v-if="item.active && deleShow"
                      style="
                        position: absolute;
                        right: -50px;
                        top: 0px;
                        right: -53px;
                        width: 37px;
                        height: 120px;
                        display: flex;
                        flex-direction: column;
                        align-items: center;
                        box-shadow: 0 2px 8px 0 rgba(0, 0, 0, 0.1);
                        background-color: #348cf8;
                        border-radius: 5px;
                        padding: 10px 0;
                      "
                    >
                      <el-tooltip
                        class="item"
                        effect="dark"
                        content="删除"
                        placement="top-start"
                      >
                        <i
                          @click.stop="deleteObj(index)"
                          style="color: #fff"
                          class="el-icon-delete-solid f24"
                        ></i>
                      </el-tooltip>
                      <el-tooltip
                        class="item"
                        effect="dark"
                        content="上移"
                        placement="top-start"
                      >
                        <i
                          @click.stop="moveComponent(index, -1)"
                          style="color: #fff"
                          class="el-icon-arrow-up f24"
                        ></i>
                      </el-tooltip>
                      <el-tooltip
                        class="item"
                        effect="dark"
                        content="下移"
                        placement="top-start"
                      >
                        <i
                          style="color: #fff"
                          class="el-icon-arrow-down f28"
                          @click.stop="moveComponent(index, 1)"
                        ></i>
                      </el-tooltip>
                    </div>
                  </template>
                </component>
              </div>
            </section>
          </div>
          <!-- 删除组件 -->
          <!-- <div
            v-if="selectedComponent.text"
            class="deles"
            :style="{ top: seletedActiveTop + 'px' }"
          >
            <span class="iconfont icon-sanjiaoxingzuo"></span>
            {{ selectedComponent.text }}
            <i class="el-icon-delete-solid" />
          </div> -->
          <!-- 底部导航栏 -->
          <div
            v-for="(item, index) in globalComponents"
            class="custom-tabbar"
            style="width: 375px; position: absolute"
          >
            <component
              v-if="item.component === 'tabbar'"
              :key="index"
              :data-index="index"
              :datas="item.setStyle"
              :data-type="item.type"
              :is="item.component"
              @click.native="activeComponent(item, index)"
              @tab-change="handleTabChange"
            />
          </div>
        </div>

        <!-- 底部 -->
      </div>
      <!-- 右侧工具栏 -->
      <div
        ref="decorateAllRef"
        class="decorateAll"
        style="border: 5px solid red"
      >
        <div>
          <!-- 页面设置 -->
          <editFormheader :datas="currentproperties" />
          <!--  -->
          <transition name="decorateAnima">
            <component
              v-show="isShowPanel"
              ref="rightPanel"
              :is="rightcom"
              :datas="currentproperties"
              @componenmanagement="componenmanagement"
            />
          </transition>
        </div>
      </div>
    </section>
    <!-- 放大预览对话框 -->
    <el-dialog
      title="预览"
      :visible.sync="isPreviewDialogOpen"
      width="375px"
      append-to-body
    >
      <!-- <vue-json-viewer :value="templateData" :expand-depth="2" /> -->
      <!-- <div>
        <img
          src="https://lingxin1314.oss-cn-beijing.aliyuncs.com/weixiaozhu/uniapp-wechart/qrcode.png"
          alt="放大二维码"
          class="preview-img"
        />
        <div class="preview-tip">提示：用微信扫描二维码，跳转至小程序</div>
      </div> -->
    </el-dialog>
  </div>
</template>

<script>
import { mapMutations, mapState } from "vuex";
import axios from "axios";
import editFormheader from "@/components/components/editFormheader";
// / 引用公共的导航栏组件
import PublicNavBar from "@/components/public/NavBar";
// 引用左侧基础组件sliderassembly
import sliderassembly from "@/components/components/sliderassembly";
import componentProperties from "@/utils/componentProperties"; // 组件数据
import html2canvas from "html2canvas"; // 生成图片
import FileSaver from "file-saver"; // 导出JSON

export default {
  name: "moduleIndexMobile",
  inject: ["reload"],
  components: {
    sliderassembly,
    PublicNavBar,
    editFormheader,
  },
  computed: {
    // 从 Vuex 状态中获取当前选中的组件（横向标签组件）
    currentComponent() {
      return this.$store.state.modules.currentComponent;
    },
    // 引用user模块的state
    ...mapState("modules", ["sliderNavbarList"]),
  },

  data() {
    return {
      isShowPanel: true, //是否显示右侧面板
      isChildrenRightPanel: false, //是否显示右侧面板内部的各个组件，用于横向标签这种组件的内部组件显示
      // 该变量用于详情跳转后返回时 style样式消失问题
      isHaveStyle: false,
      leftcom: "sliderassembly",
      iframeSrc: "http://localhost:9090/#/pages/index",
      isPreviewDialogOpen: false,
      qrBase64:
        "data:image/png;base64,eyJlcnJjb2RlIjo0MDE2OSwiZXJybXNnIjoiaW52YWxpZCBsZW5ndGggZm9yIHNjZW5lLCBvciB0aGUgZGF0YSBpcyBub3QganNvbiBzdHJpbmcgcmlkOiA2OTE1N2JmZS0xZDAwNDk3YS0zOTY0YjFmYyJ9",
      activeIndex: 0,
      activeNavbarIndex: 0,
      horizontalWidth: "63%",
      navbarList: [
        { label: "微官网", path: "" },
        { label: "PC端官网", path: "" },
      ],
      realTimeView: {
        show: false, // 是否显示预览
      },
      id: null, //当前页面
      deleShow: true, //删除标签显示
      index: "", //当前选中的index
      rightcom: "decorate", //右侧组件切换
      currentproperties: {}, //当前属性
      decorateWidth: 0, // 右侧面板宽度，用于弹出动画
      isHeaderSelected: false, // 头部导航栏选中状态
      pageSetup: {
        // 页面设置属性
        // title: "顶部标题", //页面名称
        // leftContent: "", //左侧自定义内容（文本或简单HTML，复杂内容用 left 插槽）
        // rightContent: "", //右侧按钮文本
        // showLeftArrow: false, // 是否显示左侧返回箭头（默认左箭头优先级低于 left 插槽）
        // showBorder: true, // 是否显示底部边框
        // // fixed: true, // 是否固定在顶部
        navbarBackground: "#fff", //导航栏背景颜色
        name: "首页", //页面名称
        moduleName: "智联科创园", //当前模块组件名称
        leftContent: "", // 左侧自定义内容（文本或简单HTML，复杂内容用 left 插槽）
        showLeftArrow: false, // 是否返回按钮 是否显示左侧返回箭头（默认左箭头优先级低于 left 插槽）
        details: "", //页面描述
        showBorder: true, // 是否显示底部边框
        rightContent: "", //右侧按钮文本
        titleHeight: 50, // 高度
        enterpriseName: "企业名称",
        customColor: "rgba(31, 241, 199, 1)", //自定义颜色
        details: "", //页面描述
        isPerson: false, // 是否显示个人中心
        bgColor: "rgba(249, 249, 249, 10)", //背景颜色
        // bgImg: "https://lingxin1314.oss-cn-beijing.aliyuncs.com/weixiaozhu/f9f51f2c75a86b0be94279d227048450.png", // 背景图片
      },
      pageComponents: [], //页面组件
      currentPageType: "home", //当前选中的底部导航栏类型
      offsetY: 0, //记录上一次距离父元素高度
      pointer: { show: false }, //穿透
      onlyOne: ["2-1", "1-16"], // 只能存在一个的组件(组件的type)
      selectedIndex: -1, // 当前选中的组件索引
      selectedComponent: {}, //当前选中的组件名称
      seletedActiveTop: 0,
      // 当前活动的菜单索引，用于高亮显示
      currentActiveIndex: "1", // 默认选中"模块"菜单项
      isSidebarOpen: true, // 控制侧边栏显示/隐藏的状态
      currentPageKey: "home", // 当前正在装修的页面: "首页", 默认首页
      currentPageItem: {}, // 当前正在装修的页面: "首页", 默认首页
      globalComponents: [], // 全局组件
      templateData: {}, // 最终提交保存的JSON数据
    };
  },

  mounted() {
    // this.pageSetup.name = "页面标题";
    this.currentproperties = this.pageSetup;
    console.log(
      "页面挂载默认获取 this.currentproperties",
      this.currentproperties,
    );
    // 初始化当前页面类型
    this.currentPageKey = this.$route.query.currentPageKey || "page_home";
    console.log("路由中传递过来的页面类型:", this.$route.query);
  },
  created() {
    // ****************888获取所有模版列表数据*****************
    // this.getAllTemplateList();
  },

  methods: {
    ...mapMutations("modules", ["SET_TABBAR_DATA"]),
    handleCallbackComponent(button, row) {
      // this.rightcom = button.ref
      // this.currentproperties = row
      console.log(
        "ndexMobile动态组件回调点击了选择文章按钮加载动画了",
        this.rightcom,
        button,
        row,
        button.ref,
      );
      // if (button.type === "isChildrenRightPanel") {
      //   this.isChildrenRightPanel = true;
      // } else if (button.type === "isShowPanel") {
      //   this.isChildrenRightPanel = false;
      // }
      console.log("this.rightcom", this.rightcom, this.$refs.rightPanel);
      if (button.ref !== "rightPanel")
        console.log("执行这里列......................................");
      return this.$refs.rightPanel.getComponentInstances(button);

      if (this.$refs.rightPanel.setComponentStyleAnimate) {
        this.$refs.rightPanel.setComponentStyleAnimate(button, row);
      } else {
        this.$refs.rightPanel[button.id]();
      }
      // return;
      // if (this.$refs[button.ref].$refs.rightPanel) {
      //   this.$refs[button.ref].$refs.rightPanel[button.id]();
      //   console.log("不等于空对象", this.$refs[button.ref].$refs.rightPanel);
      // } else {
      //   this.$refs[button.ref][button.id]();
      // }
      // console.log(
      //   "ndexMobile动态组件回调点击了选择文章按钮加载动画了",
      //   button,
      //   this.$refs[button.ref],
      // );
    },
    // 所有中间预览区的子组件点击跳转父组件回调方法
    handleNavigationClick(childrenDatas) {
      console.log(
        "所有中间预览区的子组件点击跳转父组件回调方法",
        childrenDatas,
        this.$store.state.modules.templateData,
      );
      if (!this.$store.state.modules.templateData.tabBar.id)
        return this.$message.error("请先添加底部导航栏");

      // 导航组类型的组件情况
      if (childrenDatas.item) {
        if (
          !childrenDatas.item.http.internalLink &&
          !childrenDatas.item.http.externalLink
        )
          return this.$message.error("请选择跳转链接");
        if (childrenDatas.item.linktype == 10) {
          // 内部跳转
          console.log("通知栏点击了内部跳转", childrenDatas);
          this.$router.push({
            path: "/productOpenwecartAfter/admin/Edit",
            query: {
              pageId: childrenDatas.item.http.internalLink,
            },
          });
        } else {
          //外部跳转
          let url = childrenDatas.item.http.externalLink.trim();
          if (!/^https?:\/\//.test(url)) url = "https://" + url;
          window.open(url, "_blank"); // 外部链接新窗口打开
          console.log("通知栏点击了外部跳转", childrenDatas, url);
        }
        return;
      }
      if (!childrenDatas.http.internalLink && !childrenDatas.http.externalLink)
        return this.$message.error("请选择跳转链接");
      // 单个组件情况
      if (childrenDatas.linktype == 10) {
        // 内部跳转
        console.log("通知栏点击了内部跳转", childrenDatas);
        this.$router.push({
          path: "/productOpenwecartAfter/admin/Edit",
          query: {
            pageId: childrenDatas.http.internalLink,
          },
        });
      } else {
        //外部跳转
        let url = childrenDatas.http.externalLink.trim();
        if (!/^https?:\/\//.test(url)) url = "https://" + url;
        window.open(url, "_blank"); // 外部链接新窗口打开
        console.log("通知栏点击了外部跳转", childrenDatas, url);
      }
    },
    // 切换侧边栏显示/隐藏
    toggleSidebar(type) {
      this.isSidebarOpen = !this.isSidebarOpen;
    },
    // 处理菜单选择事件
    handleMenuSelect(key) {
      // 更新当前活动的菜单索引，这样导航栏中对应的菜单项就会显示背景色
      this.currentActiveIndex = key;
      // 这里可以添加其他处理逻辑，比如页面跳转、加载内容等
      console.log("Selected menu item:", key);
    },
    /* 左侧“我的模块”拖拽排序完成后触发 */
    onOrderChange(newList) {
      console.log("切换位置了", newList, this.pageComponents);
      // 直接替换，保证引用不变
      // 调用函数，得到顺序和list1一致的list2
      // const resultList = this.$utils.reorderListByBase(
      //   newList,
      //   this.pageComponents,
      // );
      // this.pageComponents = resultList;
      // // this.pageComponents.splice(0, this.pageComponents.length, ...newList);
      // console.log(
      //   "左侧“我的模块”拖拽排序完成后触发",
      //   newList,
      //   this.pageComponents,
      //   resultList
      // );
    },
    // 中间手机预览区顶部导航栏有返回按钮回调
    handleLeftClick() {
      const stack = this.$store.state.modules.historyStack;
      console.log(
        "返回上一页了",
        stack,
        this.currentPageKey,
        this.$store.state.modules.templateData,
      );
      if (stack.length <= 1) {
        this.$message({
          message: "已经没有上一页了",
          type: "warning",
        });
        return;
      } // 只剩首页，不能再退
      // 1. 先弹页面栈（丢掉当前页）
      this.$store.commit("modules/POP_HISTORY");
      const prevId = stack.at(-1);
      console.log("最新页面历史访问页面id", prevId);
      // 用 replace 跳转（不再继续存储新历史页面栈）
      this.$router.replace({
        path: "/productOpenwecartAfter/admin/Edit",
        query: { pageId: prevId },
      });
    },
    // 中间手机预览区顶部导航栏有右侧按钮回调
    handleRightClick() {
      console.log("右侧按钮点击");
    },
    // 预览
    async handlePreview() {
      // 跳转到preview页面
      // 1. 通过 router 生成完整地址（含 query）
      // 用$router.resolve生成完整的预览页面URL（包含hash）
      try {
        const previewUrl = this.$router.resolve({
          name: "preview", // 匹配路由文件中preview路由的name
        }).href;
        console.log("预览页面完整URL:", previewUrl);
        // 打开新标签页
        window.open(previewUrl, "_blank");
      } catch (error) {
        console.error("预览失败:", error);
      }
    },
    // 把当前页组件写回 vuex
    saveCurrentPage(event) {
      this.currentPageKey = "page_" + event.tab.path;
      // 匹配vuex中当前pageId组件数据
      const currentPage = this.$store.state.modules.templateData.pages.find(
        (item) => item.pageId === this.currentPageKey,
      );
      //过滤当前页面的底部导航数据,
      // 更新顶部标题为当前导航项的名称 并且更新当前页面数据
      this.pageSetup.name = event.name;
      // 获取当前页面的组件数据
      let pageComponents =
        currentPage && currentPage.components ? currentPage.components : [];
      // 设置页面组件，确保始终包含底部导航栏
      this.pageComponents = pageComponents;
      console.log(
        "保存了当前页组件",
        currentPage,
        this.$store.state.modules.templateData,
        pageComponents,
        this.pageComponents,
      );
    },
    // 底部导航栏点击跳转回调
    handleTabChange(event) {
      // this.saveCurrentPage(event);
      this.$router.push({
        path: "/productOpenwecartAfter/admin/Edit",
        query: {
          pageId: `page_${event.tab.path}`,
        },
      });
      console.log(
        "底部导航栏点击回调了",
        this.currentPageKey,
        this.currentPageItem,
        event,
      );
    },
    // 顶部导航栏切换回调
    navbarClick(obj) {
      this.activeNavbarIndex = obj.index;
      this.horizontalWidth = obj.index == 0 ? "63%" : "73%";
      console.log("打印", obj);
    },
    // 组件管理点击回调
    componenmanagementClick() {
      this.rightcom = "componenmanagement";
      console.log("组件管理点击", this.rightcom, this.currentproperties);
    },
    // 保存页面组件
    Preservation() {
      /* 隐藏border和删除图标 */
      // this.deleShow = false;
      // /* 渲染结束截图 */
      // this.$nextTick(() => {
      //   /* 截图 */
      //   this.toImage();
      // });
      // 这里可以添加API调用，将publishData发送到后端
      // 例如: this.$api.publishPage(publishData)
    },
    // 根据页面类型过滤组件
    filterComponentsByUrlParam() {
      // 兼容旧方法调用
      this.filterComponentsByPageType();
    },

    // 根据页面类型过滤组件
    filterComponentsByPageType() {
      // 如果原始组件列表为空，先初始化
    },
    // ***********获取所有模版列表数据*****************
    async getAllTemplateList() {
      const response = await this.$api.admin.modules.getTemplateListAPI({
        templateId: 41,
      });
      response.data.global.isPerson = this.$utils.strToBool(
        response.data.global.isPerson,
      );
      response.data.global.showBorder = this.$utils.strToBool(
        response.data.global.showBorder,
      );
      response.data.global.showLeftArrow = this.$utils.strToBool(
        response.data.global.showLeftArrow,
      );
      response.data.tabBar.active = this.$utils.strToBool(
        response.data.tabBar.active,
      );
      response.data.tabBar.isShow = this.$utils.strToBool(
        response.data.tabBar.isShow,
      );
      response.data.tabBar.activeIndex = this.$utils.strToBool(
        response.data.tabBar.activeIndex,
      );
      response.data.tabBar.setStyle.iconList =
        response.data.tabBar.setStyle.iconList.map((item) => ({
          ...item,
          isActive: this.$utils.strToBool(item.isActive),
        }));

      console.log("结果结果结果", response);

      const datas = {
        global: response.data.global,
        pages: response.data.pages,
        tabBar: response.data.tabBar,
      };
      // 组件页面回显 存储vuex
      this.$store.commit("modules/setPageComponets", datas.pages);
      this.$store.commit("modules/SET_PUSH_TAB", datas.tabBar);
      // 设置为ture 保证中间预览区宽度正常375px

      this.isHaveStyle = true;
      this.pageComponents =
        this.$store.state.modules.templateData.pages[0].components;
      this.globalComponents = [this.$store.state.modules.templateData.tabBar];
      this.currentPageItem = this.$store.state.modules.templateData.pages[0];
      // this.globalComponents = [JSON.parse(response.data[0].content).tabBar]
      // if (response.code === 200) {
      //   this.$store.commit("modules/SET_TABBAR_DATA", response.data);
      // }
      // 存储全局gloabl页面配置
      // this.$store.commit("modules/SET_GLOBAL", this.pageSetup);
      console.log("春初了", this.currentPageItem, this.currentPageKey);

      console.log(
        "获取返回的模版列表数据结果-------------------------",
        this.globalComponents,
        this.$store.state.modules.templateData.pages,
        this.currentPageItem,
      );
    },
    // 查看JSON
    async catJson() {
      if (this.$store.state.modules.templateData.pages.length == 0)
        return this.$message.error("请先添加模版和底部导航栏");
      // this.isPreviewDialogOpen = true;
      this.templateData = this.$store.state.modules.templateData;
      // 过滤出底部导航栏的isActive 为true的项
      const activeTabbars = this.templateData.tabBar.setStyle.iconList.filter(
        (item) => item.isActive,
      );
      this.templateData.tabBar.setStyle.iconList = activeTabbars;
      // 初始化底部导航栏默认选中项
      this.templateData.tabBar.active = activeTabbars[0].iconText;
      // 后续需要时打开
      // const page_home = this.templateData.pages.find(
      //   (item) => item.pageId === "page_home",
      // );
      //  this.templateData.global.name = page_home.pageName;
      console.log("查看JSON", this.templateData);
      console.log(
        "取出vuex里的整个JSON数据",
        this.$store.state.modules.templateData,
        this.templateData,
        this.$api.admin.modules,
      );
      const response = await this.$api.admin.modules.saveTemplateListAPI({
        content: JSON.stringify(this.templateData),
      });

      console.log(
        "保存返回的模版列表数据结果-------------------------",
        response,
      );
      if (response.code === 200) {
        this.$message({
          message: "保存成功",
          type: "success",
        });
      }
      // console.log("获取返回的模版列表数据结果--------", response);
      // const json = {
      //   id: null,
      //   name: this.pageSetup.name,
      //   templateJson: this.pageSetup,
      //   component: this.pageComponents,
      // };
      // console.log("打印页面JSON结构", json);
      //   `{
      //         <br/>
      //         "id": ${this.id},
      //         <br/>
      //         "name": "${this.pageSetup.name}",
      //         <br/>
      //         "templateJson": '${JSON.stringify(this.pageSetup)}',
      //         <br/>
      //         "component": '${JSON.stringify(this.pageComponents)}',
      //         <br/>
      //       }`,
      //   "查看JSON",
      //   {
      //     confirmButtonText: "确定",
      //     customClass: "JSONView",
      //     dangerouslyUseHTMLString: true,
      //     callback: () => {},
      //   }
      // );
    },
    /**
     * 保存
     */
    handleSave() {
      this.catJson();
      /* 隐藏border和删除图标 */
      // this.deleShow = false;
      // /* 渲染结束截图 */
      // this.$nextTick(() => {
      //   /* 截图 */
      //   this.toImage();
      // });
    },

    /**
     * 页面截图
     *
     * @param {Function} callBack 回调函数
     */
    toImage() {
      /* 加载 */
      const loading = this.$loading({
        lock: true,
        text: "保存中...",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });

      const imageTofiles = document.querySelector("#imageTofile");
      /* 截图 */
      html2canvas(this.$refs.imageTofile, {
        backgroundColor: null,
        height: imageTofiles.scrollHeight,
        width: imageTofiles.scrollWidth,
        useCORS: true,
      }).then((canvas) => {
        /* 显示border和删除图标 */
        this.deleShow = true;
        let url = canvas.toDataURL("image/png");
        const formData = new FormData();
        formData.append("base64File", url);
        console.log(formData, "--------------页面图片formData");
        loading.close();
      });
    },

    /**
     * 当将元素或文本选择拖动到有效放置目标（每几百毫秒）上时，会触发此事件
     *
     * @param {Object} event event对象
     */
    allowDrop(event) {
      //阻止浏览器的默认事件
      event.preventDefault();
      /* 获取鼠标高度 */
      let eventoffset = event.offsetY;

      /* 如果没有移动不触发事件减少损耗 */
      if (this.offsetY === eventoffset) return;
      else this.offsetY = eventoffset;
      /* 获取组件 */
      const childrenObject = event.target.children[0];

      // 一个以上的组件计算
      if (this.pageComponents.length) {
        /* 如果只有一个组件并且第一个是提示组件直接返回 */
        if (
          this.pageComponents.length === 1 &&
          this.pageComponents[0].type === 0
        )
          return;

        /* 如果鼠标的高度小于第一个的一半直接放到第一个 */

        if (eventoffset < childrenObject.children[0].clientHeight / 2) {
          /* 如果第一个是提示组件直接返回 */
          if (this.pageComponents[0].type === 0) return;

          /* 删除提示组件 */
          this.pageComponents = this.pageComponents.filter(
            (res) => res.component !== "placementarea",
          );

          /* 最后面添加提示组件 */
          this.pageComponents.unshift({
            component: "placementarea",
            type: 0,
          });

          return;
        }

        /* 记录距离父元素高度 */
        const childOff = childrenObject.offsetTop;

        /* 鼠标在所有组件下面 */
        if (
          eventoffset > childrenObject.clientHeight ||
          childrenObject.lastChild.offsetTop -
            childOff +
            childrenObject.lastChild.clientHeight / 2 <
            eventoffset
        ) {
          /* 最后一个组件是提示组件返回 */
          if (this.pageComponents[this.pageComponents.length - 1].type === 0)
            return;

          /* 清除提示组件 */
          this.pageComponents = this.pageComponents.filter(
            (res) => res.component !== "placementarea",
          );

          /* 最后一个不是提示组件添加 */
          this.pageComponents.push({
            component: "placementarea",
            type: 0,
          });

          return;
        }

        const childrens = childrenObject.children;

        /* 在两个组件中间，插入 */
        for (let i = 0, l = childrens.length; i < l; i++) {
          const childoffset = childrens[i].offsetTop - childOff;

          if (childoffset + childrens[i].clientHeight / 2 > event.offsetY) {
            /* 如果是提示组件直接返回 */
            if (this.pageComponents[i].type === 0) break;

            if (this.pageComponents[i - 1].type === 0) break;

            /* 清除提示组件 */
            this.pageComponents = this.pageComponents.filter(
              (res) => res.component !== "placementarea",
            );

            this.pageComponents.splice(i, 0, {
              component: "placementarea",
              type: 0,
            });
            break;
          } else if (childoffset + childrens[i].clientHeight > event.offsetY) {
            if (this.pageComponents[i].type === 0) break;

            if (
              !this.pageComponents[i + 1] ||
              this.pageComponents[i + 1].type === 0
            )
              break;

            this.pageComponents = this.pageComponents.filter(
              (res) => res.component !== "placementarea",
            );

            this.pageComponents.splice(i, 0, {
              component: "placementarea",
              type: 0,
            });

            break;
          }
        }
      } else {
        /* 一个组件都没有直接push */
        this.pageComponents.push({
          component: "placementarea",
          type: 0,
        });
      }
    },

    /**
     * 当在有效放置目标上放置元素或选择文本时触发此事件
     *
     * @param {Object} event event对象
     */
    drop(event) {
      /* 获取数据 */
      let data = this.$utils.deepClone(
        componentProperties.get(event.dataTransfer.getData("componentName")),
      );
      console.log(
        "获取拖追后的所有组件list111111111111111111111111111",
        event.dataTransfer,
        event.dataTransfer.getData("componentName"),
        data,
        componentProperties,
        this.currentPageKey,
      );
      // 校验所拖拽的任意组件是否是我的，如果是我的不允许拖拽 只能使用默认我的页面组件
      if (this.currentPageKey === "page_user") {
        /* 清除提示组件 */
        this.pageComponents = this.pageComponents.filter(
          (res) => res.component !== "placementarea",
        );
        return this.$message.error("该系统栏目无法添加自定义模块");
      }
      /* 查询是否只能存在一个的组件且在第一个 */
      let someOne = this.pageComponents.some((item, index) => {
        return (
          item.component === "placementarea" &&
          index === 0 &&
          this.onlyOne.includes(data.type)
        );
      });
      if (someOne) {
        this.$message.info("固定位置的组件(如: 底部导航、悬浮)不能放在第一个!");
        /* 删除提示组件 */
        this.dragleaves();
        return;
      }

      /* 查询是否只能存在一个的组件 */
      let someResult = this.pageComponents.some((item) => {
        console.log("循环了", item);
        return (
          this.onlyOne.includes(item.type) &&
          item.component === event.dataTransfer.getData("componentName")
        );
      });
      console.log(
        "查询是否只能存在一个的组件666999999999999999999999999",
        this.onlyOne,
        someResult,
        this.globalComponents,
        this.pageComponents,
      );
      if (someResult) {
        this.$message.info("当前组件只能添加一个!");
        /* 删除提示组件 */
        this.dragleaves();
        return;
      }

      /* 替换 */
      this.$utils.forEach(this.pageComponents, (res, index) => {
        /* 修改选中 */
        if (res.active === true) res.active = false;
        /* 替换提示 */
        this.index = index;
        if (res.component === "placementarea")
          this.$set(this.pageComponents, index, data);
      });

      /* 切换组件 */
      this.rightcom = data.style;
      /* 丢样式 */
      this.currentproperties = data.setStyle;
      data.id =
        this.$utils.customID(data.component) + "_" + new Date().getTime();
      data.setStyle.id = data.id; //赋值模块页面id
      data.setStyle.moduleName = data.text; //赋值模块名称
      if (data.component === "tabbar") {
        const pageData = data.setStyle.iconList.map((item) => {
          return {
            pageId: this.$utils.customID(item.path), //每一个页面ID
            isBack: false, //所有的底部导航栏页面都不支持返回
            isActive: item.isActive, //是否显示当前导航栏
            pageName: item.iconText, //当前页面名称
            pageSetup: this.pageSetup, //页面全局配置
            components:
              this.currentPageKey === "page_" + item.path
                ? this.pageComponents
                : [],
          };
        });
        console.log("打印--------------", pageData);
        this.$store.commit("modules/SET_PUSH_PAGE", pageData);
        this.currentPageItem = pageData.find(
          (item) => item.pageId === this.currentPageKey,
        );
        console.log(
          "拖拽的是是是是是tabbar组件",
          data.component,
          pageData,
          this.$store.state.modules.templateData.pages,
          this.currentPageItem,
        );
      } else {
        // const storePages = this.$store.state.modules.templateData.pages || [];
        // const newPage = {
        //   pageId: this.currentPageKey,
        //   page: {
        //     ...this.currentPageItem.page,
        //     components: this.pageComponents,
        //   },
        // };
        // this.$store.commit("modules/SET_PUSH_COMPONENT", [newPage]);
        console.log(
          "拖拽的不是不是不是不是tabbar组件",
          data,
          data.component,
          this.currentPageKey,
          this.currentPageItem,
          this.$store.state.modules.templateData,
        );
        if (this.$store.state.modules.templateData.pages.length == 0) {
          const homePage = {
            pageId: this.currentPageKey,
            isBack: false, //所有的底部导航栏页面都不支持返回
            pageName: this.pageSetup.name, //当前页面名称
            pageSetup: this.pageSetup, //页面全局配置
            components: this.pageComponents,
          };
          // 调用 Vuex 封装的公共 action
          // this.$store
          //   .dispatch("modules/addDynamicPage", homePage)
          //   .then((res) => {
          //     console.log('是否存进去了', res,)
          //   }).catch((err) => {
          //   });
          console.log(
            "拖拽的不是tabbar组价，homePage",
            homePage,
            this.$store.state.modules.templateData,
          );
        }
      }

      //     });
      // 判断拖拽的必须不是底部导航栏组件  并且 vuex中没有tabBar数据 再调用this.loadTargetPage
      // if (
      //   data.component !== "tabbar" &&
      //   this.$store.state.modules.templateData.pages.length > 0
      // ) {
      //   this.loadTargetPage(data);
      // }

      console.log(
        data,
        this.rightcom,
        this.currentproperties,
        this.$store.state.modules,

        "----------components data拖拽任意组件结束后",
      );
    },
    // 读取目标页
    loadTargetPage(data) {
      let target = this.$store.state.modules.templateData.pages.find(
        (p) => p.pageId === this.currentPageKey,
      );

      console.log(
        "读取目标页",
        target,
        this.currentPageKey,
        this.currentproperties,
        this.$store.state.modules.templateData.pages,
      );

      // // 如果从未创建过，生成空壳
      // if (!target) {
      //   console.log("这个页面没有创建过");
      //   target = {
      //     pageId: this.currentPageKey,
      //     pageName: this.currentPageKey,
      //     pageSetup: { ...this.pageSetup }, // 可再调默认
      //     components: this.pageComponents,
      //   };
      //   this.$store.commit("modules/SET_PUSH_PAGE", [target]);
      // } else {
      //   console.log(
      //     "读取目标页获取",
      //     data,
      //     this.currentPageKey,
      //     target,
      //     this.$store.state.modules.templateData.pages,
      //     newTarget
      //   );
      // }
    },

    /**
     * 当拖动的元素或文本选择离开有效的放置目标时，会触发此事件
     *
     * @param {Object} event event对象
     */
    dragleaves() {
      /* 删除提示组件 */
      this.pageComponents = this.pageComponents.filter(
        (res) => res.component !== "placementarea",
      );
    },

    /**
     * 切换组件位置
     *
     * @param {Object} res 组件切换后返回的位置
     */
    componenmanagement(res) {
      console.log("组件切换后返回的位置换", res);
      this.pageComponents = res;
    },

    /**
     * 选择组件
     *
     * @param {Object} res 当前组件对象
     */
    activeComponent(res, index) {
      this.index = index;
      /* 切换组件 */
      this.rightcom = res.style;
      /* 丢样式 */
      this.currentproperties = res.setStyle;

      /* 替换 */
      this.$utils.forEach(this.pageComponents, (res) => {
        /* 修改选中 */
        if (res.active === true) res.active = false;
      });

      /* 选中样式 */
      res.active = true;
    },
    // 暂时先用这个后续有需要再打开下面的那个
    headTop() {
      this.rightcom = "decorate";

      /* 替换 */
      this.$utils.forEach(this.pageComponents, (res) => {
        /* 修改选中 */
        if (res.active === true) res.active = false;
      });
    },
    /**
     * 手机预览区顶部标题切换
     *
     * @param {Object} res 当前组件对象
     */
    headTopClick() {
      console.log("标题切换了");
      this.$nextTick(() => {
        const itemElement = document.querySelector(".headerTop");
        console.log("顶部获取dom元素--", itemElement);
        if (itemElement) {
          // // 直接使用组件最外层边框上边缘到最晚层有定位位置顶部的高度
          this.seletedActiveTop = itemElement.offsetTop + 10;
          console.log(itemElement.offsetTop);
          this.selectedComponent = {
            active: true,
            component: "headerTop",
            setStyle: {},
            style: "headerTopStyle",
            text: "顶部导航栏",
            type: "1",
          };
        }
      });
      this.rightcom = "decorate"; //默认顶部标题的右侧操作区域

      // 设置头部为选中状态
      this.isHeaderSelected = true;

      // 清除其他组件的选中状态
      this.$utils.forEach(this.pageComponents, (res) => {
        if (res.active === true) res.active = false;
      });

      // 设置右侧面板宽度以显示弹出动画
      this.decorateWidth = 380;

      // 设置当前属性为页面设置
      this.currentproperties = this.pageSetup;
    },

    /* 删除组件 */
    deleteObj(index) {
      this.pageComponents.splice(index, 1);
      if (this.index === index) this.rightcom = "decorate";
      if (index < this.index) this.index = this.index - 1;
    },
    // 组件上下移动
    moveComponent(idx, direction) {
      const list = this.pageComponents;
      const len = list.length;
      const targetIdx = idx + direction;
      // 边界保护
      if (targetIdx < 0 || targetIdx >= len) return;
      // 交换位置
      const temp = list[idx];
      this.$set(list, idx, list[targetIdx]);
      this.$set(list, targetIdx, temp);
      console.log("组件上下移动了", idx, direction, this.pageComponents);
    },

    /* 页面刷新 */
    reloads() {
      this.$confirm("重置后您添加或者修改的数据将会失效, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.reload();
        })
        .catch(() => {});
    },
    //保存当前页面

    // 检查路由中的linkUrl参数并更新页面组件
    checkRouteLinkUrl() {
      // 从路由参数中获取pageId
      const pageId = this.$route.query.pageId;
      // // 如果存在pageId参数
      if (pageId) {
        // 存储页面栈id
        this.$store.commit("modules/PUSH_HISTORY", pageId);
        // 查询Vuex中的pages数据
        const pages = this.$store.state.modules.templateData.pages || [];
        console.log("检查路由中的linkUrl参数:", this.$route.query, pages);
        //过滤vuex中的pages 和当前的pageId， 赋值当前页面item
        this.currentPageItem = pages.find((page) => page.pageId === pageId);
        // 查找匹配linkUrl的页面
        // 尝试不同的匹配策略：直接匹配、匹配page_开头的路径、或者使用linkUrl作为pageId

        let targetPage = pages.find((page) => page.pageId === pageId);
        console.log("---有没有tagetPagename", targetPage);
        if (targetPage) {
          // 专门针对详情处理
          if (
            targetPage.components.length > 0 &&
            targetPage.components[0].pageName === "详情"
          ) {
            this.currentproperties = targetPage.components[0].setStyle;
          }
          // 更新当前页面组件
          this.pageComponents = targetPage.components || [];
        }
        // 更新当前页面key
        this.currentPageKey = targetPage.pageId;
        // 更新顶部导航栏标题
        this.pageSetup.name = targetPage.pageName;
        // targetPage.pageSetup.name = targetPage.pageName;
        console.log(
          "发现pageId参数:",
          targetPage,
          pageId,
          this.pageComponents,
          this.pageSetup,
          this.currentPageKey,
          // this.$store.state.modules.historyStack,
          // pages,
          // this.currentPageItem,
        );
        return;
        if (targetPage) {
          if (targetPage.components[0].pageName === "详情") {
            this.currentproperties = targetPage.components[0].setStyle;
          }
          console.log(
            "找到匹配的页面:",
            targetPage,
            this.currentproperties,
            this.rightcom,
            this.currentPageItem,
          );

          // 把组件里对应的是否可以返回带到当前页面配置里
          // targetPage.pageSetup.showLeftArrow = this.currentPageItem.isBack;

          // // 更新全局页面设置
          // if (targetPage.pageSetup) {
          //   this.pageSetup = { ...targetPage.pageSetup };
          //   console.log(
          //     "赋值后的this。pageSetup",
          //     this.pageSetup,
          //     this.currentPageItem,
          //   );
          // }
          this.pageSetup;
          const tabbarKeyData = this.$store.state.modules.tabbarKeyData;
          const currentPageKey = this.currentPageKey.replace("page_", "");
          //判断当前的this。cureentproperties  是否在tabbarKeyData里包含，如果包含。就不需要有返回按钮 并且需要有底部导航栏
          // if (tabbarKeyData.includes(currentPageKey)) {
          //   console.log("包含底部导航栏key", currentPageKey);
          //   this.globalComponents = [
          //     this.$store.state.modules.templateData.tabBar,
          //   ];
          // } else {
          //   console.log("不包含底部导航栏key", currentPageKey);
          //   this.globalComponents = [];
          // }
          this.isHaveStyle = true;
          console.log(
            "已更新页面组件:",
            tabbarKeyData,
            this.pageComponents,
            this.pageSetup,
            this.currentproperties,
            this.globalComponents,
            this.$store.state.modules.templateData.tabBar,
            this.currentPageKey,
            this.$store.state.modules.historyStack,
          );
          console.log(
            "匹配到夜间了",
            targetPage,
            this.currentPageItem,
            this.pageComponents,
            this.currentPageKey,
            this.currentproperties,
            this.$store.state.modules.templateData,
          );
          if (targetPage.path && targetPage.path.includes("detail")) {
            console.log(
              "这里是闲情也",
              this.rightcom,
              this.currentPageItem,
              this.currentproperties,
            );
            this.rightcom = "detailstyle";
          } else {
            if (this.pageComponents.length > 0) {
              this.pageComponents[0].active = true;
              this.rightcom = "storenotecardstyle";
              this.currentproperties = this.pageComponents[0].setStyle;
            }
            console.log(
              "恢复到默认右侧面板了",
              this.rightcom,
              this.pageComponents,
              this.currentproperties,
              this.pageComponents[0],
            );
          }
        } else {
          console.log(
            "未找到匹配pageId的页面pageId:",
            pageId,
            "pages:",
            pages,
            this.pageComponents,
            this.$store.state.modules.templateData,
            this.globalComponents,
          );
        }
      }
    },

    // 返回上一步
    Previous() {
      this.$confirm("返回列表您添加或者修改的数据将会失效, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.$router.go(-1);
        })
        .catch(() => {});
    },
    //正常加载中间预览区页面数据
    loadPage(pageId) {
      console.log("正常加载中间预览区数据了", pageId);
    },
  },

  watch: {
    /* 监听路由变化，检查linkUrl参数 */
    // $route: {
    //   handler(newRoute, oldRoute) {
    //     // 检查路由中是否有linkUrl参数
    //     // this.checkRouteLinkUrl();
    //     console.log("监听到路由变化了", newRoute, oldRoute);
    //   },
    //   immediate: false, // 组件已在mounted中执行一次，这里不再立即执行
    // },
    "$route.query.pageId": {
      immediate: true,
      handler(pageId) {
        console.log(
          "监听路由的pageId了",
          pageId,
          this.$store.state.modules.historyStack,
        );
        if (!pageId || pageId === "page_undefined") return;
        this.checkRouteLinkUrl();
      },
    },

    /* 监听右侧属性设置切换 */
    rightcom(newval) {
      if (newval === "decorate") {
        this.$utils.forEach(this.pageComponents, (res) => {
          /* 修改选中 */
          if (res.active === true) res.active = false;
        });
        this.currentproperties = this.pageSetup;
        return;
      }
      if (newval === "componenmanagement") {
        /* 替换 */
        this.$utils.forEach(this.pageComponents, (res) => {
          /* 修改选中 */
          if (res.active === true) res.active = false;
        });
        this.currentproperties = this.pageComponents;
      }
      if (newval === "detailstyle") {
        this.currentproperties = this.pageComponents.find(
          (item) => item.component === "detail",
        ).setStyle;
      }
      console.log(
        "监听右侧属性设置切换---&&&&&&&&&&&&&&&&&&-",
        newval,
        this.currentPageKey,
        this.currentproperties,
        this.rightcom,
        this.pageComponents,
      );
    },
    /* 监听当前属性变化，实时更新Vuex中的tabbar数据 */
    currentproperties: {
      handler(newVal) {
        console.log(
          "监听当前属性变化",
          newVal,
          this.currentPageItem,
          this.pageComponents,
          this.currentPageKey,
          this.currentproperties,
          this.globalComponents,
        );
        // 查找当前选中的是否为tabbar组件
        const activeTabbarComponent = this.pageComponents.find(
          (component) =>
            component.active === true && component.component === "tabbar",
        );
        console.log(
          "activeTabbarComponent",
          activeTabbarComponent,
          this.pageComponents,
          this.$store.state.modules.templateData.pages,
        );
        //只有当拖入底部导航栏组件才执行以下代码
        if (newVal.parentComponent === "tabbar") {
          if (activeTabbarComponent) {
            // 更新里面的setStyle
            activeTabbarComponent.setStyle = newVal;
            // 同时更新Vuex中的tabbar数据
            this.$store.commit("modules/SET_PUSH_TAB", activeTabbarComponent);
            this.globalComponents = [activeTabbarComponent];
          }
          const vuexPages = this.$store.state.modules.templateData.pages || [];
          if (vuexPages.length > 0) {
            vuexPages.forEach((p) => {
              newVal.iconList.forEach((icon) => {
                if ("page_" + icon.path === p.pageId) {
                  p.pageName = icon.iconText;
                  console.log(
                    "打印存入111111111111111-2-122222222222222222222",
                    p,
                  );
                  this.$store.commit("modules/SET_PUSH_COMPONENT", {
                    pageId: p.pageId,
                    page: p,
                  });
                }
              });
            });
          }
          console.log(
            "底部导航栏开始变化了",
            activeTabbarComponent,
            this.$store.state.modules.templateData,
          );
          // 用于当底部导航栏变化时，实时更新vuex的底部导航栏数据
          // this.$store.state.modules.templateData.tabBar.setStyle.iconList.forEach((p) => {
          //   this.$store.commit("modules/SET_PUSH_COMPONENT", {
          //     pageId: `page_${p.path}`,
          //     page: p,
          //   });
          // });
          // 检查Vuex中是否已经存在对应的页面，避免重复添加
          // const existingPages =
          //   this.$store.state.modules.templateData.pages || [];
          // const existingPageIds = new Set(existingPages.map((p) => p.pageId));
          // // 过滤出需要新增的页面
          // const newPages = page.filter((p) => !existingPageIds.has(p.pageId));
          // console.log(
          //   "检查Vuex中是否已经存在对应的页面，避免重复添加",
          //   newPages
          // );
          // // 只有存在新页面时才提交mutation
          // if (newPages.length > 0) {
          //   this.$store.commit("modules/SET_PUSH_PAGE", newPages);
          // }
        }
        // 存储全局gloabl页面配置
        this.$store.commit("modules/SET_GLOBAL", this.pageSetup);
        console.log(
          "监听到变化了activeTabbarComponent",
          activeTabbarComponent,
          newVal,
          this.$store.state.modules.templateData,
          this.currentPageKey,
          this.currentPageItem,
        );
        /* ---------- 记录到访问栈（用于返回）---------- */
        // this.$store.commit("modules/PUSH_HISTORY", this.currentPageKey);
        // console.log(
        //   "currentproperties方法监听当前属性变化了",
        //   this.currentPageKey,
        //   this.pageComponents,
        //   newVal,
        //   activeTabbarComponent,
        //   this.$store.state.modules.templateData,
        //   this.$store.state.modules.historyStack
        // );
        // const vuexTabbarKeyData = this.$store.state.modules.tabbarKeyData;
        // //判断vuexTabbarKeyData中是否包含当前this.currentPageKey
        // console.log(
        //   "是否显示底部导航栏",
        //   this.currentproperties,
        //   this.globalComponents,
        //   vuexTabbarKeyData,
        //   this.currentPageKey
        // );
        // if (
        //   vuexTabbarKeyData.includes(this.currentPageKey.replace("page_", ""))
        // ) {
        // }
        // this.currentPageItem =
        //   this.$store.state.modules.templateData.pages.find(
        //     (p) => p.pageId === this.currentPageKey
        //   );
        // 暂时删除 有影响
        // if (this.currentPageItem) {
        //   this.currentPageItem.components = this.pageComponents;
        //   const newPage = {
        //     pageId: this.currentPageKey,
        //     page: this.currentPageItem,
        //   };
        //   this.$store.commit("modules/SET_PUSH_COMPONENT", newPage);
        // }

        console.log(
          "监听是否有tabbar了",
          this.globalComponents,
          this.pageComponents,
          this.$store.state.modules.templateData,
          this.currentPageItem,
        );
      },
      deep: true,
    },
  },
};
</script>

<style lang="scss" scoped>
.pointer-events {
  pointer-events: none;
}

.modul-home {
  width: 100%;
  height: 100%;

  /* 删除组件 */
  .deles {
    position: absolute;
    min-width: 80px;
    text-align: center;
    line-height: 25px;
    background: #fff;
    height: 25px;
    font-size: 12px;
    right: -87px;
    cursor: pointer;
    .icon-sanjiaoxingzuo {
      position: absolute;

      left: -11px;
      color: #fff;
      font-size: 12px;
      top: 50%;
      transform: translateY(-50%);
    }
    &:hover {
      i {
        display: block;
        position: absolute;
        left: 0;
        font-size: 16px;
        top: 0;
        text-align: center;
        line-height: 25px;
        width: 100%;
        color: #fff;
        height: 100%;
        z-index: 10;
        background: rgba(0, 0, 0, 0.5);
      }
      .icon-sanjiaoxingzuo {
        color: rgba(0, 0, 0, 0.5);
      }
    }

    i {
      display: none;
    }
  }

  /* 按钮集合 */
  .buttons {
    border-bottom: 1px solid #ebedf0;
    display: flex;
    justify-content: space-between;
    box-sizing: border-box;
    padding-right: 15px;
    align-items: center;
    /* 下拉 */
    .frop {
      padding-right: 15px;
      .el-button.el-button--primary.el-dropdown-selfdefine {
        background: #fff;
        color: #000;
        border: 1px solid #dcdee0;
      }
    }
    .el-button {
      font-size: 14px;
      padding: 0 16px;
      height: 30px;
      &.el-button--primary {
        background: #155bd4;
      }
      &.el-button--danger {
        background: red;
      }
    }
  }

  /* 操作主体 */
  .modul-operation {
    width: 100%;
    height: calc(100vh - 25px);
    display: flex;
    flex-direction: row;

    // 左侧导航栏容器样式
    .sidebar-container {
      height: 100%;
      flex-shrink: 0;
    }
    // 背景手机图片
    .phoneBack {
      // background-image: url('@/assets/template/phone_back.png');
      // background-size: cover;
      // background-repeat: no-repeat;
    }

    // 调整其他元素的宽度以适应新的侧边栏
    .phone {
      flex: 1;
      min-width: 0;
      height: 100%;
      overflow: hidden;
      display: flex;
      // justify-content: center;
      background: #f7f8fa;
      &::-webkit-scrollbar {
        width: 0px;
      }
      // &::-webkit-scrollbar-thumb {
      //   background-color: #155bd4;
      // }
      .headerTop {
        position: relative;
        transition: all 0.3s ease;
        cursor: pointer;
      }
      .headerTop:hover {
        // border: 1px dotted rgb(21, 91, 212);
      }
      .header-selected {
        // border: 6px solid rgb(21, 91, 212) !important;
        border: 6px solid pink !important;
      }

      /* 手机样式 */
      .phoneAll {
        width: 375px;
        height: 400px;
        height: calc(100vh - 250px);
        overflow: scroll;
        &::-webkit-scrollbar {
          //隐藏原生滚动轴
          width: 0px;
        }
        // min-height: 760px;
        // box-shadow: 0 0 14px 0 rgba(0, 0, 0, 0.1);
        // margin: 15px 0 0 0;
        position: relative;
        padding-bottom: 50px;
        .phoneBottom {
          border: 3px solid red;
          margin-top: -30px;
          // position: absolute;
          // left: -137px;
          // top: 660px;
          // font-size: 12px;
          // color: #a2a2a2;
          // border-bottom: 1px solid #dedede;
          // width: 130px;
          // height: 21px;
          // line-height: 21px;
        }

        /* 状态栏 */
        .statusBar {
          width: 100%;
          display: block;
        }
        .phone-container-isHaveStyle {
          width: 375px !important;
          // height: calc(100vh - 100px) !important;
          box-shadow: 0 0 14px 0 rgb(0 0 0 / 10%) !important;
        }
        /* 主体内容 */
        .phone-container {
          border: 6px solid pink;
          // 必须设置高度。否则拖拽组件拖拽到一定数量就看不到了
          height: 1200px;
          // padding-bottom: 100px;
          // min-height: 367px;
          box-sizing: border-box;
          background-size: cover;
          background-repeat: no-repeat;
          cursor: pointer;
          width: 100%;
          position: relative;
          background-repeat: no-repeat;
          .componentsClass {
            border: 1px solid #fff;
            // 过度效果
            transition: all 0.3s ease;
            position: relative;
            .left-name {
              position: absolute;
              padding: 5px 10px;
              left: -105px;
              background-color: #fff;
              border-radius: 4px;
              width: 88px;
              text-align: center;
              .el-icon-caret-right {
                position: absolute;
                right: -12px;
                font-size: 20px;
                color: #fff;
              }
              .el-icon-caret-right.active {
                color: #348cf8 !important;
              }
            }
            .left-name.active {
              background-color: #348cf8 !important;
              color: #fff !important;
            }
            &:hover {
              // border: 2px dashed #348cf8;
              transform: scale(1.02);
              // 过度效果
              transition: all 0.3s ease;
              box-shadow: 0 0 10px rgba(0, 0, 0, 0.2);
            }
            .el-icon-arrow-up,
            .el-icon-arrow-down,
            .el-icon-delete-solid {
              transition: all 0.3s ease;
              padding-top: 10px;
            }
            .el-icon-arrow-up:hover,
            .el-icon-arrow-down:hover,
            .el-icon-delete-solid:hover {
              transform: scale(1.3);
              // 过度效果
              transition: all 0.3s ease;
            }
          }
        }
      }
    }
  }
  /* 左侧抽屉相关样式 */
  .toggle-sidebar-btn-container {
    position: relative;
    z-index: 1;
    .toggle-sidebar-btn {
      cursor: pointer;
      position: absolute;
      width: 100px;
      height: 50px;
      background: #e5f1ff;
      box-sizing: border-box;
      border: 1px solid #ffffff;
      color: #348cf8;
      line-height: 50px;
      text-align: center;
    }
    .toggle-sidebar-btn.open {
      left: 0;
      top: 300px;
      border-radius: 0px 38px 38px 0px;
    }
    .toggle-sidebar-btn.close {
      right: 0;
      top: 650px;
      border-radius: 38px 0 0 38px;
    }
  }

  .sidebar-container {
    // position: fixed;
    // left: 0;
    // top: 0;
    // bottom: 0;
    // width: 300px;
    background-color: #fff;
    // z-index: 1000;
    box-shadow: 2px 0 8px rgba(0, 0, 0, 0.1);
    // overflow-y: auto;
  }

  /* 左侧抽屉过渡动画 */
  .sidebar-slide-enter-active,
  .sidebar-slide-leave-active {
    transition: all 0.3s ease;
  }

  .sidebar-slide-enter,
  .sidebar-slide-leave-to {
    transform: translateX(-100%);
  }

  /* 右侧工具栏 */
  .decorateAll {
    width: 450px;
    flex-shrink: 0;
    height: 100%;
    // height: calc(100vh - 60px);
    overflow-y: scroll;
    overflow-x: hidden;
    position: relative;
    padding: 0 12px;
    background: #fff;
    &::-webkit-scrollbar {
      width: 0px;
    }
    &::-webkit-scrollbar-thumb {
      background-color: #155bd4;
    }
  }

  /* 页面设置tab */
  .decorateTab {
    position: fixed;
    display: flex;
    right: 380px;
    top: 115px;
    flex-direction: column;
    span {
      background-color: #fff;
      box-shadow: 0 2px 8px 0 rgba(0, 0, 0, 0.1);
      border-radius: 2px;
      width: 94px;
      height: 32px;
      display: inline-block;
      text-align: center;
      line-height: 32px;
      margin-bottom: 12px;
      transition: all 0.8s;
      cursor: pointer;
      &.active {
        background-color: #155bd4;
        color: #fff;
      }
      /* 图标 */
      i {
        font-size: 12px;
        margin-right: 5px;
      }
    }
  }
}
/* 核心：右侧滑入/滑出过渡动画 */
/* 进入动画：从右侧外滑入 */
.decorateAnima-enter-active,
.decorateAnima-leave-active {
  transition: all 0.3s ease; /* 动画时长和缓动效果 */
}

/* 进入前的初始状态：在右侧隐藏 */
.decorateAnima-enter {
  transform: translateX(100%); /* 向右偏移100%，超出视口 */
  opacity: 0;
}

/* 离开后的最终状态：滑回右侧隐藏 */
.decorateAnima-leave-to {
  transform: translateX(100%);
  opacity: 0;
}
/* 动画 */
// .decorateAnima-enter-active {
//   transition: all 0.3s ease;
// }
// .decorateAnima-leave-active {
//   transition: all 0.3s ease;
// }
// .decorateAnima-enter {
//   transform: translate(8px, 8px);
//   opacity: 0;
// }
// .decorateAnima-leave-to {
//   transform: translate(8px, 8px);
//   opacity: 0;
// }
</style>
